import * as yup from 'yup';

interface CreateRoleRegSchemaParams {
  isEditMode: boolean;
  totalCount: number;
}

export function createRoleRegSchema(params: CreateRoleRegSchemaParams) {
  const { isEditMode, totalCount } = params;
  const maxOrder = isEditMode ? totalCount : totalCount + 1;
  const minOrder = 2;

  return yup.object({
    roleName: yup.string().trim().required('역할명(국문)은 필수 입력입니다.'),
    roleNameEn: yup.string().trim().required('역할명(영문)은 필수 입력입니다.'),
    order: yup
      .string()
      .required('순서는 필수 입력입니다.')
      .matches(/^\d+$/, '순서는 숫자만 입력 가능합니다.')
      .test('order-range', `순서는 ${minOrder}부터 ${maxOrder}까지 입력 가능합니다.`, (value) => {
        if (!value) {
          return false;
        }

        const numericValue = Number(value);

        return numericValue >= minOrder && numericValue <= maxOrder;
      }),
  });
}
